import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the SalesSalesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-waiters-movements',
  templateUrl: 'waiters-movements.html',
})
export class WaitersMovementsPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  movements = 0;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'waiter', name: this.translate.instant('general-nombre') },
    { prop: 'movements', name: this.translate.instant('sales-analytics-movimientos') },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  //datatable
  rowsList = [];
  tempList = [];
  columnsList = [
    { prop: 'waiter', name: this.translate.instant('general-nombre') },
    { prop: 'type', name: this.translate.instant('general-tipo') },
    { prop: 'element', name: this.translate.instant('general-elemento') },
    { prop: 'date', name: this.translate.instant('general-fecha') },
  ];
  @ViewChild(DatatableComponent) tableList: DatatableComponent;
  ColumnModeList = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController) {
    this.getAnalyticsData();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;//boolean check
    //waiters_movements
    this.http.post(this.globals.analytics_path + 'analytics/waiters_movements', params, {})
      .subscribe(async response => {
        //
        this.movements = response['movements'];
        //list
        this.rowsList = response['list'];
        this.tempList = response['list'];
        //this.chartCheck = true;//boolean check
      });
    //waiters_movements_per_waiter
    this.http.post(this.globals.analytics_path + 'analytics/waiters_movements_per_waiter', params, {})
      .subscribe(async response => {
        //charts
        //this.chartData = response['movements_data']['data'];
        this.chartLabels = response['movements_data']['labels'];

        this.chartData = {
          labels: this.chartLabels,
          datasets: response['movements_data']['data']
        };
        //list
        this.rows = response['list'];
        this.temp = response['list'];
        this.chartCheck = true;//boolean check
      });
  }

  updateFilterList(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const tempList = this.tempList.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rowsList = tempList;
    // Whenever the filter changes, always go back to the first page
    this.tableList.offset = 0;
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.waiter.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const params = new HttpParams()
      .set('data', JSON.stringify(this.rowsList.map((x) => { return { 'Waiter': x.waiter, 'Type': x.type, 'Element': x.element, 'Date': x.date } })))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({}));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/waiters-movements/waiters-movements.ts